export default __webpack_public_path__ + "static/media/google-security-assessment.fe20ebe2.svg";